/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-nested-ternary */
import React, {
    MutableRefObject,
    useCallback,
    useEffect,
    useRef,
    useState,
} from "react"
import Icon from "@mui/material/Icon"
import {
    Avatar,
    Button,
    CircularProgress,
    Typography,
    Box,
    Fab,
    Tooltip,
} from "@mui/material"
import { useTranslation } from "react-i18next"
import clsx from "clsx"
import { useDropzone } from "react-dropzone"
import ImageService from "../../services/image"
import { PageConfig, CwComponentConfig } from "../../models/pageConfig"
import UIService from "../../services/UIService"
import StoreService from "../../services/store"
import { Action } from "../../models/action"
import ActionService from "../../services/action"
import DynamicParamsService from "../../services/dynamicParams"
import DialogService from "../../services/dialog"
import { DialogType } from "../../models/dialog"
import FormFieldService from "../../services/formField"
import ComponentsUtils from "../../utils/components"

const CwImage = (
    props: PageConfig<CwComponentConfig.Image> & {
        onSubmit?: (value: any) => void
    }
): React.JSX.Element | null => {
    const imageService = ImageService.getInstance()
    const inputFile: MutableRefObject<HTMLInputElement | null> = useRef(null)
    const { config } = props
    const {
        alt,
        labelText,
        className,
        containerClassName,
        edit,
        defaultImage,
        acceptFileInput,
        clickable,
        context,
        fieldName, // si dans form
        useRefreshListener,
        onClickActions,
        formLink,
    } = config
    const publicFileUpload = config.public || false
    const [isDownloading, setIsDownloading] = useState<boolean>(true)
    const [uploadState, setUploadState] = useState({
        isUploading: false,
        progress: 0,
        uploadSucceed: false,
    })
    const [label, setLabel] = useState<string>("")
    const { t } = useTranslation()
    const variant = config?.variant ? config.variant : "circular"
    // state avec tous les params modifiables
    // ici on met setValue de type string
    const [value, setValue] = useState<string>(config.value || defaultImage)
    const [tooltip, setTooltip] = useState<string | undefined>(config.tooltip)
    const getFormState = (field: string, currentValue: unknown) => {
        return FormFieldService.getInstance().send(
            formLink,
            field,
            currentValue
        )
    }
    /**
     * Gestion de la selection d'un fichier image
     * @param event React.FormEvent<HTMLInputElement>
     */
    const handleInputFileChange = (event: any) => {
        if (event?.target?.files && event.target.files.length) {
            const formData = new FormData()
            const file = event.target.files[0]
            if (file.size < ImageService.imageLimitSize()) {
                formData.append("file", file)
                formData.append("readonly", "true")
                formData.append("public", publicFileUpload ? "true" : "false")
                // on utilise l'injection de dépendence car des comportements change en fonction de l'app
                const { source, endPoint } =
                    StoreService.getSourceEndPoint("GedService.upload")

                if (source && endPoint) {
                    endPoint
                        .apply(source, [
                            formData,
                            (res: any) => {
                                if (res && res.progress) {
                                    setUploadState({
                                        ...uploadState,
                                        isUploading: true,
                                        uploadSucceed: false,
                                        progress: res.progress,
                                    })
                                }
                            },
                        ])
                        .then(
                            (data: any) => {
                                if (data) {
                                    // set le src courrant avec l'id ged
                                    setValue(`#ged.${data}`)
                                    // save l'id ged dans le store local
                                    if (fieldName) {
                                        StoreService.getInstance().local.set(
                                            fieldName,
                                            `#ged.${data}`
                                        )
                                        getFormState(fieldName, data)
                                    }
                                    // met à jour la variable indiaquant qu'un upload vient d'etre fait
                                    setUploadState({
                                        ...uploadState,
                                        uploadSucceed: true,
                                        isUploading: false,
                                    })

                                    // appel de la callback de submit si def
                                    if (typeof props.onSubmit === "function")
                                        props.onSubmit(`#ged.${data}`)
                                }
                            },
                            () => {
                                UIService.getInstance().showErrorToast(
                                    t("errChangePicture"),
                                    "CwImage"
                                )
                                setUploadState({
                                    ...uploadState,
                                    isUploading: false,
                                })
                            }
                        )
                }
            } else
                UIService.getInstance().showErrorToast(
                    t("errSizePicture"),
                    "CwImage"
                )
        }
    }

    const onDrop = useCallback(
        (acceptedFiles: any) => {
            const fakeEvent = {
                target: {
                    files: acceptedFiles,
                },
            }

            handleInputFileChange(fakeEvent)
        },
        [props]
    )
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    })

    const init = () => {
        // exec les actions d'init
        if (props.actions && props.actions.length)
            ActionService.exec(props.actions, context).then((conf) => {
                // override des attrs de state par ceux de conf
                // -----> dans icon
                if (conf?.type === "config") {
                    setValue(conf.value.value)
                    setTooltip(conf.value.tooltip)
                }
            })
        if (value)
            DynamicParamsService.resolve([value]).then(
                (result) => {
                    let newSrc: any = ""
                    if (result && result.length && result[0]) {
                        newSrc = result[0] as string
                        setValue(newSrc)
                    } else {
                        //  newSrc = defaultImage
                        setValue(defaultImage as string)
                    }
                    setIsDownloading(false)
                    // sync avec le store
                    if (fieldName)
                        StoreService.getInstance().local.set(fieldName, newSrc)
                },
                (err) => {
                    console.log(err)
                }
            )
        else setIsDownloading(false)

        if (labelText) resolveText()
    }

    const resolveText = () => {
        DynamicParamsService.resolve([config.labelText]).then(
            (result) => {
                if (result) {
                    setLabel(result[0] as string)
                }
            },
            (err) => {
                console.error(err)
            }
        )
    }

    useEffect(() => {
        let subId: string | null = null
        // on s'abonne aux changements de route
        if (useRefreshListener)
            subId = DialogService.getInstance().subscribe(
                "pageRefesh",
                DialogType.REFRESH,
                props.name,
                () => {
                    init()
                }
            )
        init()
        // unsubscribe
        return () => {
            if (subId) DialogService.getInstance().unsubscribe(subId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    /**
     * Gestion du click sur le bouton de modification de l'image
     */
    const handleChangeImageClick = () => {
        if (
            inputFile?.current?.click &&
            typeof inputFile.current.click === "function"
        )
            inputFile.current.click()
    }

    /**
     * handleClick gére les clics sur les images clickable
     */
    const handleClickOnImage = () => {
        // récupère les actions à faire lors du click
        if (onClickActions) {
            // ici c'est onClickActions
            const actions: Array<Action> = onClickActions
            // executer les actions
            ActionService.exec(actions, context).then(
                () => {},
                (err) => {
                    console.error(err)
                }
            )
        }
    }
    /**
     * Fait le rendu de l'image en mode view
     * @returns React Element
     */
    const renderImage = (): any => {
        if (isDownloading) {
            return (
                <Avatar
                    className={`avatar ${containerClassName}`}
                    variant={variant}
                >
                    <CircularProgress color="primary" />
                </Avatar>
            )
        }
        if (value && value.indexOf("#ged") !== -1) {
            setIsDownloading(true)
            ImageService.resolveImage(value)
                .then((data) => {
                    setValue(data || (defaultImage as string))
                })
                .finally(() => setIsDownloading(false))
            return null
        }

        if (value && clickable && !config.tooltip) {
            return (
                <Button onClick={handleClickOnImage}>
                    <img
                        alt={alt}
                        src={imageService.getImage(value)}
                        className={className}
                    />
                </Button>
            )
        }
        if (value && tooltip) {
            return (
                <Tooltip title={tooltip} arrow>
                    <img
                        alt={alt}
                        src={imageService.getImage(value)}
                        className={className}
                    />
                </Tooltip>
            )
        }
        if (value && !tooltip) {
            return (
                <img
                    alt={alt}
                    src={imageService.getImage(value)}
                    className={className}
                />
            )
        }

        return null
    }

    /**
     * Fait un rendue de l'icon upload pour ajouter une photo
     * @returns React.JSX.Element
     */
    const renderUpload = (): React.JSX.Element => {
        return (
            <div
                className="fullWidth dropInnerContainer"
                {...getRootProps({
                    onClick: (event) => event.stopPropagation(),
                })}
            >
                {uploadState.isUploading ? (
                    ComponentsUtils.renderLoader(
                        uploadState.progress,
                        "progress"
                    )
                ) : (
                    <>
                        <Icon className="dropIcon">cloud_upload</Icon>
                        <Typography variant="h6">
                            {isDragActive ? t("releasePicture") : t("dndHere")}
                        </Typography>
                        <Typography variant="h4">{t("or")}</Typography>
                        <Button
                            onClick={handleChangeImageClick}
                            className="outlinedButtonGrey"
                        >
                            <Icon className="avatarIcon">upload</Icon>
                            <Typography variant="button">
                                {t("pickFile")}
                            </Typography>
                        </Button>
                        <Typography variant="caption">
                            <p>{t("maxFileSize")}</p>
                            <p>{t("fileFormats")}</p>
                        </Typography>
                    </>
                )}
            </div>
        )
    }
    /**
     * Fait le rendu de l'image quand elle est en mode edit
     * @returns React Element
     */
    const renderEditImage = (): React.JSX.Element => {
        return (
            <Box
                alignItems="baseline"
                display="flex"
                flexDirection="row"
                className="fullWidth mb-2 maxWidthUltraLarge"
            >
                {label && <Typography className="m-2">{t(label)}</Typography>}
                <input
                    {...getInputProps()}
                    ref={inputFile}
                    type="file"
                    className="hidden"
                    accept={acceptFileInput}
                    onChange={handleInputFileChange}
                />
                <Avatar
                    className={clsx(`avatar editAvatar ${containerClassName}`, {
                        dndActive: isDragActive,
                    })}
                    variant={variant}
                >
                    {/* on rend l'image si src est défini ou si un upload vient d'etre fait */}
                    {uploadState.uploadSucceed || value ? (
                        <>
                            <Fab
                                variant="extended"
                                className="retryButton"
                                onClick={handleChangeImageClick}
                            >
                                <Icon fontSize="large">sync</Icon>
                                {t("changer")}
                            </Fab>

                            {renderImage()}
                        </>
                    ) : (
                        renderUpload()
                    )}
                </Avatar>
            </Box>
        )
    }

    return edit ? renderEditImage() : renderImage()
}

export default CwImage
